(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb20-kinetic"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb20-kinetic')) {
  customElements.define('bb20-kinetic', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const abort = new AbortController();
      const options = { signal: abort.signal };
      const buttons = Array.from(this.querySelectorAll('[data-gallery-button]'));
      const panels = Array.from(this.querySelectorAll('[data-gallery-panel]'));
      const controls = this.querySelector('[data-gallery-controls]');
      if (buttons.length && controls) {
        controls.hidden = false;
        panels.forEach((panel, index) => { panel.hidden = index !== 0; });
        buttons.forEach((button) => button.addEventListener('click', () => {
          buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          panels.forEach((panel) => { panel.hidden = panel.id !== button.getAttribute('aria-controls'); });
        }, options));
      }
      const stage = this.querySelector('[data-tilt]');
      const picture = this.querySelector('[data-tilt-image]');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      let frame = null;
      const enabled = () => this.dataset.motion === 'true' && !reduce.matches && fine.matches;
      const reset = () => { if (frame) cancelAnimationFrame(frame); frame = null; if (picture) picture.style.transform = ''; };
      if (stage && picture) {
        stage.addEventListener('pointermove', (event) => {
          if (!enabled() || frame) return;
          const rect = stage.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - .5;
          const y = (event.clientY - rect.top) / rect.height - .5;
          frame = requestAnimationFrame(() => { picture.style.transform = `rotate(-5deg) rotateX(${-y * 7}deg) rotateY(${x * 9}deg) translateY(${-y * 5}px)`; frame = null; });
        }, options);
        stage.addEventListener('pointerleave', reset, options);
      }
      reduce.addEventListener('change', reset, options);
      const videos = Array.from(this.querySelectorAll('video'));
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); }), { threshold: .05 });
        videos.forEach(video => observer.observe(video));
      }
      document.addEventListener('visibilitychange', () => { if (document.hidden) videos.forEach(video => video.pause()); }, options);
      this.cleanup = () => { abort.abort(); observer?.disconnect(); reset(); };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb20-product-reviews"] && !Shopify.designMode) return;
  try {
    
  function bb20RevealFeedbackResult(root = document) {
    root.querySelectorAll('.bb20-feedback__message').forEach((message) => {
      const details = message.closest('details');
      if (details) details.open = true;
    });
  }
  bb20RevealFeedbackResult();
  document.addEventListener('shopify:section:load', (event) => bb20RevealFeedbackResult(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obs-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ob-gallery')) customElements.define('ob-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready='true';
      const buttons=Array.from(this.querySelectorAll('[data-ob-photo]'));
      const panels=Array.from(this.querySelectorAll('[data-ob-panel]'));
      if (!buttons.length) return;
      const select = value => {panels.forEach(p => p.hidden=p.dataset.obPanel!==value);buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.obPhoto===value)));};
      select(buttons[0].dataset.obPhoto);
      this.querySelector('.ob-gallery__controls').hidden=false;
      buttons.forEach((button,index)=>{button.addEventListener('click',()=>select(button.dataset.obPhoto));button.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();let next=event.key==='Home'?0:event.key==='End'?buttons.length-1:(index+(event.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;buttons[next].focus();select(buttons[next].dataset.obPhoto);});});
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obs-film"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ob-film'))customElements.define('ob-film',class extends HTMLElement{
    connectedCallback(){if(this.observer)return;this.video=this.querySelector('video');if(!this.video)return;this.onVisibility=()=>{if(document.hidden)this.video.pause();};document.addEventListener('visibilitychange',this.onVisibility);this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)this.video.pause();}),{threshold:0.1});this.observer.observe(this);}
    disconnectedCallback(){this.observer?.disconnect();document.removeEventListener('visibilitychange',this.onVisibility);this.observer=null;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obs-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ob-motion-scope')) {
    const initObsidianMotion = (scope) => {
      scope.querySelectorAll('[data-ob-tilt]').forEach((stage) => {
        if (stage.dataset.ready) return;
        stage.dataset.ready = 'true';
        const root = stage.closest('[data-ob-motion]');
        const enabled = () => root?.dataset.obMotion === 'true' && matchMedia('(pointer:fine)').matches && !matchMedia('(prefers-reduced-motion:reduce)').matches;
        stage.addEventListener('pointermove', (event) => {
          if (!enabled()) return;
          const box = stage.getBoundingClientRect();
          stage.style.setProperty('--ob-rx', `${(0.5-(event.clientY-box.top)/box.height)*5}deg`);
          stage.style.setProperty('--ob-ry', `${((event.clientX-box.left)/box.width-0.5)*7}deg`);
        });
        stage.addEventListener('pointerleave', () => {stage.style.setProperty('--ob-rx','0deg');stage.style.setProperty('--ob-ry','0deg');});
      });
    };
    customElements.define('ob-motion-scope', class extends HTMLElement {});
    initObsidianMotion(document);
    document.addEventListener('shopify:section:load', event => initObsidianMotion(event.target));
  }

  } catch(e) { console.error(e); }
})();
})();
